import { Modal } from '@/ui-kit';
import { ToolItem } from './components/tool-item';
import { SettingsData, settingsData } from './settings-data';
import { useTranslation } from 'react-i18next';

interface Props {
    isOpen?: boolean;
    onClose?: () => void;
    handleChangeSettingsProfile: (settings: SettingsData['action']) => void;
    username?: string;
}

export const ModalSettingsUserChat: React.FC<Props> = ({ isOpen, onClose, handleChangeSettingsProfile, username }) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('msgs.security_toolkit')}>
            {settingsData.map((item) => {
                const IconComponent = item.icon;
                return (
                    <ToolItem
                        key={item.titleTranslationKey}
                        title={`${t(item.titleTranslationKey)} ${username ? username : ''}`}
                        text={t(item.typeTranslationKey)}
                        icon={<IconComponent />}
                        onClick={() => handleChangeSettingsProfile(item.action)} />
                );
            })}
        </Modal>
    );
};
